export default "__VITE_ASSET__BZYJnwEe__"